import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Sheet from '../../components/Sheet'
import ActionBar from '../../components/ActionBar'

export default function ChangeUserPass(props) {
    const { t } = useTranslation()
    const { targetUser, showChangePass, setShowChangePass, fetchResource } = props
    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')
    const [badPass, setBadPass] = useState(false)
    const [badConfPass, setBadConfPass] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    async function handleSubmit() {
        let [pass, passConf] = [password, passwordConfirm]
        pass = pass.trim()
        passConf = passConf.trim()

        if (pass === '') {
            setBadPass(true)
            setErrorMessage(t('users.passwordRequired'))
            return
        } else {
            setBadPass(false)
        }
        if (pass.length < 6) {
            setBadPass(true)
            setErrorMessage(t('users.changePasswordTooShort'))
            return
        } else {
            setBadPass(false)
        }
        if (!passConf) {
            setBadConfPass(true)
            setErrorMessage(t('users.passwordRequired'))
            return
        } else {
            setBadConfPass(false)
        }
        if (pass !== passConf) {
            setBadConfPass(true)
            setErrorMessage(t('users.passwordMismatch'))
            return
        } else {
            setBadConfPass(false)
        }

        try {
            await fetchResource({
                resource: 'users/update-password',
                body: { username: targetUser, password: pass },
                blocking: true
            })
            window.location.reload(false)
            setShowChangePass(false)
        } catch (error) {
            console.error(error)
            alert(t('users.changePasswordUnexpectedError'), error)
        }
    }

    // Clean up errors and fields when modal closes
    useEffect(() => {
        if (!showChangePass) {
            return () => {
                setPassword('')
                setPasswordConfirm('')
                setBadPass(false)
                setBadConfPass(false)
                setErrorMessage('')
            }
        }
    }, [showChangePass])

    return (
        showChangePass && (
            <Sheet
                open={showChangePass}
                onClose={() => setShowChangePass(false)}
                title={t('users.changePasswordTitle')}
                actions={
                    <ActionBar
                        cancel={{ label: t('common.cancel'), onClick: () => setShowChangePass(false) }}
                        confirm={{ label: t('common.submit'), onClick: handleSubmit }}
                    />
                }
            >
                {/* A flex column rather than a spaced Grid container: Grid spacing
                    works by negative margins on the container, which inside a
                    DialogContent's own padding pulls the fields out past its left
                    edge -- the exact overflow the old fixed 313px box had. */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* Whose password this is. It used to be an h5 under a centered
                        title; the sheet titles itself, so this is the subject line. */}
                    <Typography variant='h6'>{targetUser}</Typography>
                    <TextField
                        error={badPass}
                        helperText={badPass && errorMessage}
                        fullWidth
                        required
                        id='password'
                        label={t('users.passwordLabel')}
                        type='password'
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    <TextField
                        error={badConfPass}
                        helperText={badConfPass && errorMessage}
                        fullWidth
                        required
                        id='password-confirm'
                        label={t('users.confirmPasswordLabel')}
                        type='password'
                        value={passwordConfirm}
                        onChange={e => setPasswordConfirm(e.target.value)}
                    />
                </Box>
            </Sheet>
        )
    )
}
